// extracted by mini-css-extract-plugin
export default {"backdrop":"LoadingDiv_backdrop__mL+hZ"};